import React from 'react'
import PropTypes from 'prop-types'
import Section from '../../Section'
import Interweave from 'interweave'
import { convertMdToHtml } from '..'

const OperationalConsiderations = ({ report: { reportContent } }) => (
  <Section title="Operational Considerations">
    <Interweave
      content={convertMdToHtml.makeHtml(reportContent.summary.operationalConsiderations)}
    />
  </Section>
)

OperationalConsiderations.propTypes = {
  report: PropTypes.object,
}

export default OperationalConsiderations
